import FullPageLoader from '@/components/full-page-loader';
import { SentryObserver } from '@/lib/sentry/observer';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { memo } from 'react';

export const Route = createFileRoute('/_authenticated')({
  component: memo(AuthenticationLayout),
  beforeLoad: async ({ context }) => {
    // delay 1 seconds
    await new Promise((resolve) => setTimeout(resolve, 1000));
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.pathname,
        },
      });
    }
  },
  pendingComponent: FullPageLoader,
});

function AuthenticationLayout() {
  return (
    <>
      <SentryObserver />
      <Outlet />
    </>
  );
}
